// src/api/adminGradingApi.js
import api from './axios';

export const getAllGradingResults = (params = {}) =>
  api.get('/admin/grading/results', { params });

export const runAdminGrading = (reservationId) =>
  api.post('/grading/run/' + reservationId);

export const getGradingStats = (days = 30) =>
  api.get('/admin/grading/stats?days=' + days);
